import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import Translate from "utils/translate";

import styles from "./SelectAll.css";

const { t } = new Translate("SelectAll");

const SelectAll = ({ isAllSelected, isSelected, onClear, onSelectAll }) => (
  <div className={styles.root}>
    <button
      className={classnames(styles.selectAll, {
        [styles.hidden]: isAllSelected,
      })}
      onClick={onSelectAll}
      type="button"
    >
      {t("selectAll")}
    </button>
    <button
      className={classnames(styles.clear, {
        [styles.hidden]: !(isSelected || isAllSelected),
      })}
      onClick={onClear}
      type="button"
    >
      {t("clear")}
    </button>
  </div>
);

SelectAll.propTypes = {
  onSelectAll: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
  isAllSelected: PropTypes.bool,
};

export default SelectAll;
